import { ProQuery } from '@libs/graphql/types'

export enum ProTabTab {
  Fans = 'repeat-bookings',
  Marketing = 'new-bookings',
  ManageGuests = 'manage-guests',
}

export const isProTabTab = (
  tab: string | null | undefined
): tab is ProTabTab => {
  if (!tab) return false
  return Object.values(ProTabTab).includes(tab as ProTabTab)
}

export type FansTabInfo = NonNullable<ProQuery['pro']['fans']>
export type MarketingTabInfo = NonNullable<ProQuery['pro']['marketing']>
